'use client';

import { c as _c } from "react/compiler-runtime";
import type { User } from '@/data/types/user';
import { api } from '@/data/api';
import { createContext, use, useCallback, useEffect, useMemo, useState, type ReactNode } from 'react';
export type UserSessionContextValue = {
  user?: User;
  refreshUser: () => Promise<User | undefined>;
  updateUser: (value: User | undefined | ((current: User | undefined) => User | undefined)) => void;
};
export const UserSession = createContext<UserSessionContextValue>({
  user: undefined,
  refreshUser: async () => undefined,
  updateUser() {}
});
export function UserSessionContextProvider(t0) {
  const $ = _c(10);
  const {
    children,
    user: initialUser
  } = t0;
  const [user, setUser] = useState(initialUser);
  let t1;
  let t2;
  if ($[0] !== initialUser) {
    t1 = () => setUser(initialUser);
    t2 = [initialUser];
    $[0] = initialUser;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = async () => {
      const response = await api.organization.user.authentication.session.fetch().catch(_temp);
      const next = response && typeof response === "object" && "user" in response ? response.user as User | undefined : undefined;
      setUser(next?._id ? next : undefined);
      return next?._id ? next : undefined;
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const refreshUser = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = value => {
      setUser(current => typeof value === "function" ? value(current) : value);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const updateUser = t4;
  let t5;
  if ($[5] !== user) {
    t5 = {
      user,
      refreshUser,
      updateUser
    };
    $[5] = user;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const value_0 = t5;
  let t6;
  if ($[7] !== children || $[8] !== value_0) {
    t6 = <UserSession.Provider value={value_0}>{children}</UserSession.Provider>;
    $[7] = children;
    $[8] = value_0;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp() {}
export function useUserSession() {
  return use(UserSession).user;
}
export function useUserSessionContext() {
  return use(UserSession);
}